<div
  class="d-flex align-items-center"
  [class.rtl]="common.isRtl"
  [class.ltr]="!common.isRtl"
  style="gap: 10px"
>
  <div class="countdown-box">
    <span>{{ remainingTime.days | number : "2.0" }}</span>
    <small>{{ "day" | translate }}</small>
  </div>
  <div class="countdown-box">
    <span>{{ remainingTime.hours | number : "2.0" }}</span>
    <small>{{ "hour" | translate }}</small>
  </div>
  <div class="countdown-box">
    <span>{{ remainingTime.minutes | number : "2.0" }}</span>
    <small>{{ "minute" | translate }}</small>
  </div>
  <div class="countdown-box">
    <span>{{ remainingTime.seconds | number : "2.0" }}</span>
    <small>{{ "second" | translate }}</small>
  </div>
</div>
